import React, { lazy, Suspense } from 'react'
import LoadingComponent from 'components/generic/LoadingComponent'

const LazyComponent = lazy(() => import(/* webpackChunkName: "tutorialOverview" */ './'))

export default function TutorialOverviewLazy(props) {
  return (
    <Suspense fallback={<LoadingComponent />}>
      <LazyComponent {...props} />
    </Suspense>
  )
}
